"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const authenticator_1 = require("../../authenticator");
const features_1 = require("../../features");
const eventBus_1 = require("../../eventBus");
const plugins_1 = require("../../xhr/plugins");
const uiInformation_1 = require("../../uiInformation");
(0, eventBus_1.initGlobalEventBus)();
const configureFramework = (Session, bankId, language, Authoriser, additionalPlugins = []) => {
    //TODO Session needs XHR Authplugin and this plugin needs session
    Session.setXHR(new features_1.XHR([...additionalPlugins, new features_1.XHRAcceptLanguagePlugin(language), new features_1.XHRAuthPlugin(Session), new features_1.XHRBankIdPlugin(bankId)]));
    const plugins = [
        ...additionalPlugins,
        new features_1.XHRAcceptLanguagePlugin(language),
        new features_1.XHRBankIdPlugin(bankId),
        new plugins_1.XHRTrustedChallengePlugin(Authoriser),
    ];
    const AuthApi = new features_1.XHR({ plugins });
    const Authenticator = new authenticator_1.MbAuthenticator(Session, AuthApi, uiInformation_1.getDeviceUUID);
    return {
        Authenticator,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map